import React from "react";
import { colorWhite } from "../../../utility/constants/colorManager";
import {
  PERCENTAGE,
  RUPEES,
  RUPEES_SYMBOL,
} from "../../../utility/constants/valueConstants";
import { Divider } from "./ComissionContainer";
import { MdOutlineDeleteOutline } from "react-icons/md";

export function SlabContainerComp({
  from,
  to,
  value,
  type,
  id,
  onClickDelete,
  isEditClicked = false,
}) {
  return (
    <div key={id} style={styles.mainContainerStyle}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <MdOutlineDeleteOutline
          size={20}
          style={{
            cursor: "pointer",
          }}
          onClick={() => onClickDelete(id)}
        />
      </div>
      <div style={styles.containerStyle}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 0.55,
            rowGap: 20,
            width: "100%",
          }}
        >
          <div>
            <p>From</p>

            <div style={styles.boxStyle}>
              <p>{from}</p>
            </div>
          </div>
          <div>
            <p>To</p>

            <div style={styles.boxStyle}>
              <p>{to}</p>
            </div>
          </div>
        </div>
        <Divider
          style={{
            display: "flex",
            margin: "0px 10px",
          }}
        />
        <div
          style={{
            display: "flex",
            flex: 0.4,
            padding: "0px 10px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 30,
            }}
          >
            <div style={styles.boxStyle}>
              <p>{type === PERCENTAGE ? "%" : RUPEES_SYMBOL}</p>
            </div>

            <div style={styles.boxStyle}>
              <p>{value}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  inputStyle: {
    alignSelf: "center",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    width: "100%",
  },
  containerStyle: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    width: "100%",
    justifyContent: "space-between",
    margin: "10px 0px",
  },
  boxStyle: {
    minWidth: 50,
    border: "1px solid #CBCBCB",
    width: 60,
    height: 40,
    margin: 0,
    backgroundColor: colorWhite,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  mainContainerStyle: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #CBCBCB",
    borderRadius: 5,
    padding: "10px",
    flexDirection: "column",
    marginBottom: 10,
  },
};

export default SlabContainerComp;
